// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"RealTime_wrapper__2f3cP"};